if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      connectedCallback() {
        this.sourceButton = document.getElementById(this.dataset.sourceButton);
        this.stickyButton = this.querySelector('[data-sticky-add-to-cart]');
        this.buttonLabel = this.stickyButton?.querySelector('span');
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.sourceIsVisible = true;

        if (!this.sourceButton || !this.stickyButton) {
          this.hidden = true;
          return;
        }

        this.stickyButton.addEventListener('click', this.handleClick);
        this.mediaQuery.addEventListener('change', this.handleViewportChange);
        this.handleViewportChange();
      }

      disconnectedCallback() {
        this.stickyButton?.removeEventListener('click', this.handleClick);
        this.mediaQuery?.removeEventListener('change', this.handleViewportChange);
        this.stopObservers();
      }

      handleClick = () => {
        if (this.stickyButton.disabled) return;
        this.sourceButton.click();
      };

      handleViewportChange = () => {
        if (this.mediaQuery.matches) {
          this.startObservers();
        } else {
          this.stopObservers();
        }
      };

      startObservers() {
        if (this.intersectionObserver || this.mutationObserver) return;

        this.intersectionObserver = new IntersectionObserver(
          ([entry]) => {
            this.sourceIsVisible = entry.isIntersecting;
            this.updateVisibility();
          },
          { threshold: 0 }
        );
        this.intersectionObserver.observe(this.sourceButton);

        this.mutationObserver = new MutationObserver(() => this.syncFromSource());
        this.mutationObserver.observe(this.sourceButton, {
          attributes: true,
          attributeFilter: ['aria-disabled', 'aria-haspopup', 'disabled'],
          childList: true,
          subtree: true,
        });

        this.syncFromSource();
      }

      stopObservers() {
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
        this.intersectionObserver = undefined;
        this.mutationObserver = undefined;
        this.hidden = true;
      }

      syncFromSource() {
        const disabled =
          this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
        const sourceLabel = this.sourceButton.querySelector('span')?.textContent?.trim();
        const popup = this.sourceButton.getAttribute('aria-haspopup');

        this.stickyButton.disabled = disabled;
        this.stickyButton.setAttribute('aria-disabled', String(disabled));

        if (sourceLabel && this.buttonLabel) this.buttonLabel.textContent = sourceLabel;

        if (popup) {
          this.stickyButton.setAttribute('aria-haspopup', popup);
        } else {
          this.stickyButton.removeAttribute('aria-haspopup');
        }

        this.updateVisibility();
      }

      updateVisibility() {
        this.hidden = !this.mediaQuery.matches || this.sourceIsVisible || this.stickyButton.disabled;
      }
    }
  );
}

if (!customElements.get('product-estimated-delivery')) {
  customElements.define(
    'product-estimated-delivery',
    class ProductEstimatedDelivery extends HTMLElement {
      connectedCallback() {
        const minimumDays = Math.max(0, Number.parseInt(this.dataset.minDays, 10) || 0);
        const maximumDays = Math.max(minimumDays, Number.parseInt(this.dataset.maxDays, 10) || minimumDays);
        const excludeWeekends = this.dataset.excludeWeekends === 'true';
        const startDate = this.addDays(new Date(), minimumDays, excludeWeekends);
        const endDate = this.addDays(new Date(), maximumDays, excludeWeekends);
        const formatter = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
          month: 'short',
          day: 'numeric',
        });
        const range = this.dataset.rangeTemplate
          .replace('[start_date]', formatter.format(startDate))
          .replace('[end_date]', formatter.format(endDate));
        const rangeElement = this.querySelector('.product-estimated-delivery__range');

        if (rangeElement) rangeElement.textContent = range;
      }

      addDays(date, days, excludeWeekends) {
        const result = new Date(date);
        result.setHours(12, 0, 0, 0);
        let addedDays = 0;

        while (addedDays < days) {
          result.setDate(result.getDate() + 1);
          const isWeekend = result.getDay() === 0 || result.getDay() === 6;
          if (!excludeWeekends || !isWeekend) addedDays += 1;
        }

        return result;
      }
    }
  );
}
